import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';

import type { RovoPresenceColorMode } from './RovoPresenceIcon.tsx';

export const useAgentAvatarColorMode = (): RovoPresenceColorMode => {
	const { colorMode } = useThemeObserver();
	return colorMode === 'dark' ? 'dark' : 'light';
};
